<template>
    <div v-if="themeStore.themeIndex === 3">
        <WithdrawPW />
    </div>
    <StatusPopup ref="statusRef" />
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue';
import { useThemeStore } from '@/stores/theme';
import WithdrawPW from '@/themes/themeThree/withdraw/withdrawPWPage.vue';

const themeStore = useThemeStore()
</script>
<style scoped>

</style>